import { d } from './chunk-6EFRS222.mjs';
import o from 'styled-components';

var t=o(d)`
  font-family: var(--font-family-mono);
`,r=t;var a=o.h1`
  margin: 0;
  color: var(--foreground-primary);
  font-size: var(--font-size-x-large);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-x-small);
`,l=a;

export { r as a, l as b };
